import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import GalleryService from '@/services/gallery.service';
import PostInfo from "@/shared-components/forms/add-board-content/add-post/published-post/PostInfo";
import ContentMetaDesc from '@/shared-components/forms/add-board-content/shared-components/ContentMetaDesc';
import Loader from "@/shared-components/loader/Loader";
import { getSsrContentBootstrap } from '@/utils/ssrContentBootstrap';

import PostNotFound from '../../../../pages/profile/post/components/PostNotFound';
import PostTags from '../../../../pages/profile/post/post-tags';
import Header from "../shared-components/outside-header";

import './post.css';

export default function Post() {
  const { postId, articleId } = useParams();
  const resolvedPostId = postId || articleId;
  const ssrBootstrap = getSsrContentBootstrap(resolvedPostId);

  const [{
    loading,
    error,
    data,
  }, setPostFetched] = useState({
    loading: !ssrBootstrap?.data,
    error: ssrBootstrap?.forceNotFound === true,
    data: ssrBootstrap?.data ?? null,
  });

  useEffect(() => {
    if (!resolvedPostId || ssrBootstrap?.data) {
      return;
    }

    GalleryService.getPublicContentWithSeoById(resolvedPostId)
      .then(response => {
        setPostFetched({
          loading: false,
          data: response.data,
          error: null,
        });
      })
      .catch(() => {
        setPostFetched({
          loading: false,
          data: null,
          error: true,
        });
      });

  }, [resolvedPostId, ssrBootstrap?.data]);

  if(loading) {
    return (
      <>
        <Loader/>
      </>
    );
  } else if(error) {
    return (
      <PostNotFound/>
    );
  } else {
    return (
      <>
        <div className="post__container">
          <ContentMetaDesc content={data}/>
          <Header fetchData={data}/>

          <main className="post__main post__main--no-cover">
            <div className="post__content">
              <PostInfo fetchData={data}/>
              <PostTags postTags={data.post_container.post_tags} fetchData={data}/>
            </div>
          </main>
        </div>
      </>
    );
  }
}
